import type { Locale } from "@/i18n/types";

/** Set `VITE_GOOGLE_PLAY_URL` in `.env` when the listing is live. */
export const GOOGLE_PLAY_LISTING_URL =
  import.meta.env.VITE_GOOGLE_PLAY_URL?.trim() || "#hero";

export const GOOGLE_PLAY_QR_CODE_SRC =
  "/assets/images/qrcode_google_play.png";

export function isExternalPlayStoreUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}

const BADGE_EN =
  "/assets/logos/GetItOnGooglePlay_Badge_Web_color_English.svg";

const BADGE_SRC: Partial<Record<Locale, string>> = {
  en: BADGE_EN,
  ru: "/assets/logos/GetItOnGooglePlay_Badge_Web_color_Russian.svg",
  lv: "/assets/logos/GetItOnGooglePlay_Badge_Web_color_Latvian.svg",
  es: "/assets/logos/GetItOnGooglePlay_Badge_Web_color_Spanish.svg",
  de: "/assets/logos/GetItOnGooglePlay_Badge_Web_color_German.svg",
  fr: "/assets/logos/GetItOnGooglePlay_Badge_Web_color_French.svg",
};

export function googlePlayBadgeSrc(locale: Locale): string {
  return BADGE_SRC[locale] ?? BADGE_EN;
}
